"use client";

import { Toaster as Sonner, ToasterProps } from "sonner";
import { useApp } from "@/contexts/AppContext";

const Toaster = ({ ...props }: ToasterProps) => {
    const { activeTheme } = useApp();
    const toastStyles = {
        "--normal-bg":
            "color-mix(in srgb, var(--surface) 88%, var(--background))",
        "--normal-text": "var(--foreground)",
        "--normal-border":
            "color-mix(in srgb, var(--foreground) 12%, var(--background))",
        "--success-bg":
            "color-mix(in srgb, var(--primary) 18%, var(--surface))",
        "--success-text": "var(--foreground)",
        "--success-border":
            "color-mix(in srgb, var(--primary) 28%, var(--background))",
        "--info-bg":
            "color-mix(in srgb, var(--primary) 14%, var(--surface))",
        "--info-text": "var(--foreground)",
        "--info-border":
            "color-mix(in srgb, var(--primary) 22%, var(--background))",
        "--warning-bg":
            "color-mix(in srgb, var(--accent) 14%, var(--surface))",
        "--warning-text": "var(--foreground)",
        "--warning-border":
            "color-mix(in srgb, var(--accent) 22%, var(--background))",
        "--error-bg":
            "color-mix(in srgb, var(--accent) 22%, var(--surface))",
        "--error-text": "var(--foreground)",
        "--error-border":
            "color-mix(in srgb, var(--accent) 30%, var(--background))",
    } as React.CSSProperties;

    return (
        <Sonner
            theme={activeTheme.tone as ToasterProps["theme"]}
            className="toaster group"
            style={toastStyles}
            {...props}
        />
    );
};

export {Toaster};
